import React from 'react';
import { Link } from 'react-router-dom';
import heroImage from '../assets/hero-illustration.svg';
import clientLogo1 from '../assets/bnp.png';
import clientLogo2 from '../assets/engie.png';
import clientLogo3 from '../assets/ag.png';
import clientLogo4 from '../assets/ing.png';
import clientLogo5 from '../assets/proximus.png';
import solutionIcon1 from '../assets/consulting.png';
import solutionIcon2 from '../assets/developement.png';
import solutionIcon3 from '../assets/cloud.png';
import expertImage from '../assets/techstride-values-illustration.svg';
import './style.css';

function HomePage() {
    return (
        <div className="homepage">
            
            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-content">
                    <h1>Innovative IT solutions to transform your business</h1>
                    <p>TechStride Consulting supports you in your digital transformation with tailor-made solutions and recognized expertise.</p>
                    <div className="hero-buttons">
                        <Link to="/services" className="secondary-button">Discover our services</Link>
                        <Link to="/contact" className="primary-button">Contact us</Link>
                    </div>
                </div>
                <div className="hero-image">
                    <img src={heroImage} alt="Digital Transformation" />
                </div>
            </section>

            {/* Services Section */}
            <section className="services-section">
                <div className="section-header">
                    <h2>Our Areas of Expertise</h2>
                    <p>Discover our comprehensive range of IT services designed to meet your specific needs.</p>
                </div>

                <div className="services-grid">
                    <div className="service-card">
                        <img src={solutionIcon1} alt="Consulting IT" />
                        <h3>Consulting IT</h3>
                        <p>Digital strategy, technical audits, IT governance & support for your transformation projects.</p>
                    </div>

                    <div className="service-card">
                        <img src={solutionIcon2} alt="Custom Development" />
                        <h3>Custom Development</h3>
                        <p>Design and development of web and mobile applications, system integration, and application modernization.</p>
                    </div>

                    <div className="service-card">
                        <img src={solutionIcon3} alt="Cloud Services" />
                        <h3>Cloud Services</h3>
                        <p>Cloud migration, cloud architecture, cost optimization, and securing your infrastructures.</p>
                    </div>
                </div>
            </section>

            {/* About Section */}
            <section className="about-section">
                <div className="about-image">
                    <img src={expertImage} alt="Notre expertise" />
                </div>
                <div className="about-content">
                    <h2>Why choose TechStride Consulting?</h2>
                    <div className="about-features">
                        <div className="feature">
                            <h3>Technical Expertise</h3>
                            <p>Our team of experts masters the latest technologies and methodologies to ensure high-performance solutions.</p>
                        </div>
                        <div className="feature">
                            <h3>Strategic Vision</h3>
                            <p>We align our technological solutions with your business objectives to maximize your ROI.</p>
                        </div>
                        <div className="feature">
                            <h3>Personalized Support</h3>
                            <p>We support you at every stage of your project, from strategy to implementation and support.</p>
                        </div>
                    </div>
                    <Link to="/about" className="about-link">Discover our approach</Link>
                </div>
            </section>

            {/* Clients Section */}
            <section className="clients-section">
                <h2>They trust us</h2>
                <div className="client-logos">
                    <img src={clientLogo1} alt="Client Logo" />
                    <img src={clientLogo2} alt="Client Logo" />
                    <img src={clientLogo3} alt="Client Logo" />
                    <img src={clientLogo4} alt="Client Logo" />
                    <img src={clientLogo5} alt="Client Logo" />
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <h2>Ready to transform your business?</h2>
                <p>Contact us today to discuss your projects and specific needs.</p>
                <Link to="/contact" className="cta-button">Schedule a meeting</Link>
            </section>

            {/* Footer */}

        </div>
    );
}

export default HomePage;